import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-editable-section',
  templateUrl: './editable-section.component.html',
  styleUrls: ['./editable-section.component.scss']
})
export class EditableSectionComponent {

  @Output()
  onEdit = new EventEmitter<any>();

  @Input()
  isEditable = true;

  @Input()
  isEditing = false;

  edit()
  {
    if (!this.isEditable) return;
    this.onEdit.next();
  }

}
